import UTIF from "utif2"

function applyExifOrientation(data: Uint8Array, width: number, height: number, orientation: number): {data: Uint8Array; width: number; height: number} {
    if (!(orientation >= 2 && orientation <= 8)) return {data, width, height}

    const swap = orientation >= 5
    const dstW = swap ? height : width
    const dstH = swap ? width : height
    const w1 = width - 1
    const h1 = height - 1

    const coeffs: Record<number, [number, number, number, number, number, number]> = {
        2: [w1, -1, 0, 0, 0, 1],
        3: [w1, -1, 0, h1, 0, -1],
        4: [0, 1, 0, h1, 0, -1],
        5: [0, 0, 1, 0, 1, 0],
        6: [0, 0, 1, h1, -1, 0],
        7: [w1, 0, -1, h1, -1, 0],
        8: [w1, 0, -1, 0, 1, 0],
    }
    const [a0, a1, a2, b0, b1, b2] = coeffs[orientation] ?? [0, 1, 0, 0, 0, 1]

    const out = new Uint8Array(data.length)
    for (let y = 0; y < dstH; y++) {
        for (let x = 0; x < dstW; x++) {
            const sc = a0 + a1 * x + a2 * y
            const sr = b0 + b1 * x + b2 * y
            const si = (sr * width + sc) * 4
            const di = (y * dstW + x) * 4
            out[di] = data[si]
            out[di + 1] = data[si + 1]
            out[di + 2] = data[si + 2]
            out[di + 3] = data[si + 3]
        }
    }
    return {data: out, width: dstW, height: dstH}
}

export function decodeTiffToImageData(buffer: Uint8Array): ImageData {
    const arrayBuffer = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength) as ArrayBuffer
    const ifds = UTIF.decode(arrayBuffer)
    if (ifds.length === 0) throw new Error("TIFF contains no image data")
    const ifd = ifds[0]
    UTIF.decodeImage(arrayBuffer, ifd)
    const rgba = UTIF.toRGBA8(ifd)
    const orientationTag = ifd.t274
    const orientation = Array.isArray(orientationTag) ? Number(orientationTag[0]) : 1
    const oriented = applyExifOrientation(rgba, ifd.width, ifd.height, orientation)
    return new ImageData(
        new Uint8ClampedArray(oriented.data.buffer as ArrayBuffer, oriented.data.byteOffset, oriented.data.byteLength),
        oriented.width,
        oriented.height,
    )
}
